import type { IRepairRequestSubmissionFilters } from '@/types/rc/filters'
import type { ICustomerRepairRequestSubmissionForm, IUpdateRepairSubmissionStatusForm } from '@/types/rc/forms'
import type { IRepairRequestSubmission } from '@/types/rc/repair-requests/RepairRequestSubmission'
import type { IPage } from '@/types/shared/pagination'
import axios from 'axios'

/**
 * Gets all repair request submissions with optional filters.
 *
 * @param filters repair request submission filters.
 * @returns repair request submission dashboard data.
 * @throws {AxiosError}
 */
export async function getRepairRequestSubmissions(
  filters?: IRepairRequestSubmissionFilters
): Promise<IPage<IRepairRequestSubmission>> {
  const res = await axios.get(import.meta.env.VITE_APP_RC_REPAIR_REQUEST_SUBMISSIONS_ENDPOINT, {
    params: filters,
  })
  return res.data
}

/**
 * Delete a repair request submission
 *
 * @param submissionID the repair request submission ID
 */
export async function deleteRepairRequestSubmission(submissionID: number) {
  const res = await axios.delete(`${import.meta.env.VITE_APP_RC_REPAIR_REQUEST_SUBMISSIONS_ENDPOINT}/${submissionID}`)
  return res.data
}

/**
 * Updates a submission status
 *
 * @param form update submission status form.
 * @returns {Promise<any>} updated submission.
 * @throws {AxiosError}
 */
export async function updateRepairRequestSubmissionStatus(
  submissionID: number,
  form: IUpdateRepairSubmissionStatusForm
): Promise<any> {
  const res = await axios.patch(
    `${import.meta.env.VITE_APP_RC_REPAIR_REQUEST_SUBMISSIONS_ENDPOINT}/${submissionID}`,
    form
  )
  return res.data
}

export async function createCustomerRepairRequestSubmission(form: ICustomerRepairRequestSubmissionForm): Promise<any> {
  const res = await axios.post(import.meta.env.VITE_APP_RC_CUSTOMER_REPAIR_REQUEST_SUBMISSIONS_ENDPOINT, form)
  return res.data
}
